"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CYBERSOURCE_CANCEL_MESSAGE_TYPE = exports.CYBERSOURCE_SUBMIT_MESSAGE_TYPE = exports.PaymentType = exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
})(Currency || (exports.Currency = Currency = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["CC"] = "CC";
    PaymentType["ACH"] = "ACH";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
exports.CYBERSOURCE_SUBMIT_MESSAGE_TYPE = 'cybersourcePaymentSubmitCallback';
exports.CYBERSOURCE_CANCEL_MESSAGE_TYPE = 'cybersourceCancelCallback';
